import { render, staticRenderFns } from "./OrthoPlanButtons.vue?vue&type=template&id=15ebe7d4&scoped=true&"
import script from "./OrthoPlanButtons.vue?vue&type=script&lang=js&"
export * from "./OrthoPlanButtons.vue?vue&type=script&lang=js&"
import style0 from "./OrthoPlanButtons.vue?vue&type=style&index=0&id=15ebe7d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ebe7d4",
  null
  
)

export default component.exports